function isName(val) {
    return /^([\u4E00-\u9FA5A-Za-z\d]+([ .\-_][\u4E00-\u9FA5A-Za-z\d]+)*)$/.test(val) || val === '';
}

function isPlainText(val) {
    return !/[^\u4E00-\u9FA5A-Za-z0-9`\-=~!@#$%^&*()_+{}|[\]\\:";'<>?,./ ！￥……（）——【】：；“”‘’《》？，。、\n\r]/.test(val);
}

function isMobile(val) {
    return /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(val) || val === '';
}

function isTel(val) {
    return /^(([0+]\d{2,3}-)?(0\d{2,3})-)(\d{7,8})(-(\d{3,}))?$/.test(val) || val === '';
}

function isMail(val) {
    return /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(val) || val === '';
}

export default {
    isName,
    isMobile,
    isTel,
    isPlainText,
    isMail,
};
